import { useEffect, useState } from "react";
import { api } from "@/api";
import { LayoutAutenticado } from "@/componentes/LayoutAutenticado";

export default function RankingApostador() {
  const [dados, setDados] = useState({ ranking: [], totalArrecadado: 0 });
  const [rodada, setRodada] = useState("");
  const [rankingRodada, setRankingRodada] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/publico/ranking");
      setDados(data || { ranking: [] });
    })();
  }, []);

  useEffect(() => {
    if (!rodada) return setRankingRodada([]);
    (async () => {
      const { data } = await api.get(`/publico/ranking-rodada/${rodada}`);
      setRankingRodada(data || []);
    })();
  }, [rodada]);

  return (
    <LayoutAutenticado>
      <div data-testid="pagina-ranking-apostador">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-amarelobrasil">Classificação</div>
            <h1 className="font-heading text-4xl font-bold uppercase mt-1">Ranking</h1>
          </div>
          <select
            value={rodada}
            onChange={(e) => setRodada(e.target.value)}
            className="surface-card px-4 py-2.5 rounded-md text-sm border border-white/10"
            data-testid="select-ranking-rodada"
          >
            <option value="">Geral</option>
            {[1,2,3,4,5,6,7].map((r) => <option key={r} value={r}>{"Rodada " + r}</option>)}
          </select>
        </div>

        <TabelaRanking
          dados={rodada ? rankingRodada : dados.ranking}
          modoRodada={!!rodada}
        />
      </div>
    </LayoutAutenticado>
  );
}

function TabelaRanking({ dados, modoRodada }) {
  if (!dados || dados.length === 0) {
    return (
      <div className="surface-card rounded-2xl p-10 text-center text-white/50">
        Sem dados de ranking ainda.
      </div>
    );
  }
  return (
    <div className="surface-card rounded-2xl overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-white/5 text-[10px] uppercase tracking-widest text-white/50 font-bold">
          <tr>
            <th className="px-4 py-3 text-left">#</th>
            <th className="px-4 py-3 text-left">Apostador</th>
            <th className="px-4 py-3 text-right">Pontos</th>
            <th className="px-4 py-3 text-right hidden md:table-cell">Exatos</th>
            <th className="px-4 py-3 text-right hidden md:table-cell">Brasil exatos</th>
            <th className="px-4 py-3 text-right hidden md:table-cell">{modoRodada ? "Acertos" : "Palpites"}</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-white/5">
          {dados.map((r, i) => (
            <tr key={r.usuarioId || i} className="hover:bg-white/[0.02]" data-testid={`ranking-linha-${i+1}`}>
              <td className="px-4 py-3 font-heading font-black tabular-nums w-12 text-white/40">{String(i + 1).padStart(2, "0")}</td>
              <td className="px-4 py-3 font-bold">{r.usuario?.nomePublico || r.usuario?.nomeCompleto}</td>
              <td className="px-4 py-3 text-right font-heading font-black text-amarelobrasil tabular-nums">
                {modoRodada ? r.pontuacaoRodada : r.pontuacaoTotal}
              </td>
              <td className="px-4 py-3 text-right tabular-nums hidden md:table-cell">
                {modoRodada ? r.totalPlacaresExatosRodada : r.totalPlacaresExatos}
              </td>
              <td className="px-4 py-3 text-right tabular-nums hidden md:table-cell">
                {modoRodada ? "—" : r.totalPlacaresExatosBrasil}
              </td>
              <td className="px-4 py-3 text-right tabular-nums hidden md:table-cell">
                {modoRodada ? r.totalAcertosRodada : r.totalPalpites}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
